module.exports = __webpack_public_path__ + "static/staff_of_charming-5920f5e52a388846b2dbc97d491151e6.jpeg";